"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const PageWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;
const SuccessContainer = (0, styled_components_1.default)(material_1.Paper) `
  max-width: 600px;
  width: 100%;
  padding: 32px;
  text-align: center;

  .success-icon {
    color: #4caf50;
    font-size: 64px;
    margin-bottom: 16px;
  }

  .action-buttons {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    gap: 16px;
  }
`;
const PaymentSucceeded = props => {
    const { currentLocale } = props;
    const [locale, setLocale] = (0, react_1.useState)(currentLocale || 'en');
    const history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(() => {
        const sessionLocale = sessionStorage.getItem('currentLocale');
        if (sessionLocale) {
            setLocale(sessionLocale);
            sessionStorage.removeItem('currentLocale');
        }
    }, []);
    const handleReturn = () => {
        const venueSlug = sessionStorage.getItem('paymentReturnVenueSlug');
        if (venueSlug) {
            history.push(`/${venueSlug}/bookings`);
            sessionStorage.removeItem('paymentReturnVenueSlug');
        }
        else {
            history.push('/');
        }
    };
    return (react_1.default.createElement(PageWrapper, null,
        react_1.default.createElement(SuccessContainer, { elevation: 1 },
            react_1.default.createElement(CheckCircle_1.default, { className: "success-icon" }),
            react_1.default.createElement(material_1.Typography, { variant: "h4", gutterBottom: true }, i18n_js_1.default.t('payment_successful', { locale })),
            react_1.default.createElement("div", { className: "action-buttons" },
                react_1.default.createElement(material_1.Button, { variant: "contained", color: "primary", onClick: handleReturn }, i18n_js_1.default.t('go_to_bookings', { locale }))))));
};
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(PaymentSucceeded);
